import "regenerator-runtime";
import * as React from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useTranslation } from "react-i18next";
import { CGI_BLACK, versions } from "../helpers/enums";
import { Button, ButtonGroup, IconButton, Popover } from "@mui/material";

export default function AdditionalActions({
  assessment,
  setNotificationMessage,
  setOpenNotification,
  setOpenLoading,
  fetchData,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  async function createNewVersion(shortVersion) {
    setOpenLoading(true);
    try {
      /*const requestBody = {
        customer: customer,
        parsedModule: parsedModule,
        version: module.version,
        shortVersion: shortVersion,
      };
      const apiName = "CreateNewAssessmentVersionApi";
      let path = "/newAssessmentVersion";
      const options = {
        body: requestBody,
      };
      const answer = await API.post(apiName, path, options);
      */
      fetchData();
      setNotificationMessage("Not implemented yet");
      //setNotificationMessage(t("successNewVersion"));
    } catch (error) {
      console.error(error);
      setNotificationMessage(t("errorMessage"));
    }
    setOpenNotification(true);
    setOpenLoading(false);
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          border: 1,
          borderRadius: 20,
          mr: 5,
          width: 25,
          height: 25,
          color: CGI_BLACK,
        }}
      >
        <MoreHorizIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <ButtonGroup orientation="vertical" variant="text">
          {versions[assessment.type] === versions.TWO_DIMENSIONAL ? (
            <Button
              sx={{ textTransform: "none" }}
              onClick={() => {
                createNewVersion(false);
                handleClose();
              }}
            >
              {t("createNewVersionFine")}
            </Button>
          ) : (
            <Button
              sx={{ textTransform: "none" }}
              onClick={() => {
                createNewVersion(true);
                handleClose();
              }}
            >
              {t("createNewVersionStandard")}
            </Button>
          )}
        </ButtonGroup>
      </Popover>
    </>
  );
}
